import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { ArrowRight, ChevronLeft, ChevronRight } from "lucide-react";
import { Link } from "react-router-dom";

import studioImage01 from "../assets/studio-images/studio-image01.webp";
import studioImage02 from "../assets/studio-images/studio-image02.webp";
import studioImage03 from "../assets/studio-images/studio-image03.webp";
import studioImage04 from "../assets/studio-images/studio-image04.webp";
import studioImage05 from "../assets/studio-images/studio-image05.webp";
import studioImage06 from "../assets/studio-images/studio-image06.webp";
import studioImage07 from "../assets/studio-images/studio-image07.webp";
import studioImage08 from "../assets/studio-images/studio-image08.webp";
import studioImage09 from "../assets/studio-images/studio-image09.webp";
import studioImage10 from "../assets/studio-images/studio-image10.webp";
import studioImage11 from "../assets/studio-images/studio-image11.webp"; 
import studioImage12 from "../assets/studio-images/studio-image12.webp";
import studioImage13 from "../assets/studio-images/studio-image13.webp";
import studioImage14 from "../assets/studio-images/studio-image14.webp";
import studioImage15 from "../assets/studio-images/studio-image15.webp";
import studioImage16 from "../assets/studio-images/studio-image16.webp";
import studioImage17 from "../assets/studio-images/studio-image17.webp";
import studioImage18 from "../assets/studio-images/studio-image18.webp";
import studioImage19 from "../assets/studio-images/studio-image19.webp";
import studioImage20 from "../assets/studio-images/studio-image20.webp";
import studioImage21 from "../assets/studio-images/studio-image21.webp";
import studioImage22 from "../assets/studio-images/studio-image22.webp";
import studioImage23 from "../assets/studio-images/studio-image23.webp";
import studioImage24 from "../assets/studio-images/studio-image24.webp";
import studioImage25 from "../assets/studio-images/studio-image25.webp";
import studioImage26 from "../assets/studio-images/studio-image26.webp";
import studioImage27 from "../assets/studio-images/studio-image27.webp";
import studioImage28 from "../assets/studio-images/studio-image28.webp";
import studioImage29 from "../assets/studio-images/studio-image29.webp";
import studioImage30 from "../assets/studio-images/studio-image30.webp";
import studioImage31 from "../assets/studio-images/studio-image31.webp";
import studioImage32 from "../assets/studio-images/studio-image32.webp";
import studioImage33 from "../assets/studio-images/studio-image33.webp";
import studioImage34 from "../assets/studio-images/studio-image34.webp";
import studioImage35 from "../assets/studio-images/studio-image35.webp";
import studioImage36 from "../assets/studio-images/studio-image36.webp";
import studioImage37 from "../assets/studio-images/studio-image37.webp";
import studioImage38 from "../assets/studio-images/studio-image38.webp";
import studioImage39 from "../assets/studio-images/studio-image39.webp";
import studioImage40 from "../assets/studio-images/studio-image40.webp";
import studioImage41 from "../assets/studio-images/studio-image41.webp";
import { studioImageAlt } from "../studioImageAlts";

const ALL_IMAGES = [
  studioImage01,
  studioImage02,
  studioImage03,
  studioImage04,
  studioImage05,
  studioImage06,
  studioImage07,
  studioImage08,
  studioImage09,
  studioImage10,
  studioImage11,
  studioImage12,
  studioImage13,
  studioImage14,
  studioImage15,
  studioImage16,
  studioImage17,
  studioImage18,
  studioImage19,
  studioImage20,
  studioImage21,
  studioImage22,
  studioImage23,
  studioImage24,
  studioImage25,
  studioImage26,
  studioImage27,
  studioImage28,
  studioImage29,
  studioImage30,
  studioImage31,
  studioImage32,
  studioImage33,
  studioImage34,
  studioImage35,
  studioImage36,
  studioImage37,
  studioImage38,
  studioImage39,
  studioImage40,
  studioImage41,
];

const shuffleArray = (array) => {
  const shuffled = [...array];
  for (let i = shuffled.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
  }
  return shuffled;
};

export default function HomeGallerySection() {
  const images = useMemo(() => {
    return shuffleArray(ALL_IMAGES).slice(0, 6);
  }, []);

  const rowRef = useRef(null);
  const [canPrev, setCanPrev] = useState(false);
  const [canNext, setCanNext] = useState(true);

  const updateArrows = useCallback(() => {
    const row = rowRef.current;
    if (!row) return;
    setCanPrev(row.scrollLeft > 8);
    setCanNext(row.scrollLeft + row.clientWidth < row.scrollWidth - 8);
  }, []);

  useEffect(() => {
    updateArrows();
    window.addEventListener("resize", updateArrows);
    return () => window.removeEventListener("resize", updateArrows);
  }, [updateArrows]);

  const scrollByCard = (direction) => {
    const row = rowRef.current;
    if (!row || !row.firstElementChild) return;
    const card = row.firstElementChild.getBoundingClientRect().width;
    row.scrollBy({ left: direction * (card + 16), behavior: "smooth" });
  };

  return (
    <section className="border-t border-black/10 bg-[#fff7fb]">
      <div className="mx-auto max-w-7xl px-6 sm:px-10 lg:px-16 xl:px-10 py-16 md:py-20">
        {/* Heading */}
        <div className="text-center">
          <p className="text-sm uppercase tracking-[0.3em] text-pink-500/80">
            Gallery
          </p>

          <h2 className="mt-3 text-3xl font-semibold tracking-tight text-black md:text-4xl">
            A glimpse into our work
          </h2>

          <p className="mx-auto mt-4 max-w-2xl text-sm leading-relaxed text-black/65 md:text-base">
            Explore a curated collection of our photography, showcasing our
            style, creativity, and attention to detail.
          </p>
        </div>

        {/* Images */}
        {/* swipeable row on phones and tablets, four-up grid on desktop */}
        <div className="relative">
        <div
          ref={rowRef}
          onScroll={updateArrows}
          className="no-scrollbar -mx-6 mt-12 flex snap-x snap-mandatory gap-4 overflow-x-auto px-6 pb-4 sm:-mx-10 sm:px-10 lg:mx-0 lg:grid lg:grid-cols-4 lg:overflow-visible lg:px-0 lg:pb-0">
          {images.map((img, index) => (
            <div
              key={index}
              className={[
                "group w-[72%] shrink-0 snap-center overflow-hidden rounded-[1.75rem] border border-black/10 bg-white shadow-[0_20px_50px_rgba(0,0,0,0.08)] sm:w-[44%] lg:w-auto",
                index >= 4 ? "lg:hidden" : "",
              ].join(" ")}
            >
              <div className="h-[400px] w-full overflow-hidden sm:h-[480px] lg:h-[560px]">
                <img
                  src={img}
                  alt={studioImageAlt(ALL_IMAGES.indexOf(img))}
                  className="h-full w-full object-cover object-center transition duration-700 group-hover:scale-105"
                  loading={index < 3 ? "eager" : "lazy"}
                  decoding="async"
                />
              </div>
            </div>
          ))}
        </div>

        <button
          type="button"
          onClick={() => scrollByCard(-1)}
          disabled={!canPrev}
          aria-label="Previous photos"
          className="absolute left-2 top-1/2 z-10 flex h-11 w-11 -translate-y-1/2 items-center justify-center rounded-full bg-white text-[#1c1c1c] shadow-[0_8px_20px_rgba(0,0,0,0.25)] transition hover:bg-pink-50 disabled:pointer-events-none disabled:opacity-0 lg:hidden"
        >
          <ChevronLeft size={22} />
        </button>
        <button
          type="button"
          onClick={() => scrollByCard(1)}
          disabled={!canNext}
          aria-label="Next photos"
          className="absolute right-2 top-1/2 z-10 flex h-11 w-11 -translate-y-1/2 items-center justify-center rounded-full bg-white text-[#1c1c1c] shadow-[0_8px_20px_rgba(0,0,0,0.25)] transition hover:bg-pink-50 disabled:pointer-events-none disabled:opacity-0 lg:hidden"
        >
          <ChevronRight size={22} />
        </button>
        </div>

        {/* CTA */}
        <div className="mt-10 text-center">
          <Link
            to="/gallery"
            className="inline-flex rounded-full border-2 border-pink-500 bg-pink-500 px-7 py-3 text-[15px] font-semibold text-white shadow-[0_8px_20px_rgba(0,0,0,0.18)] transition hover:-translate-y-0.5 hover:border-pink-600 hover:bg-pink-600 active:scale-95 items-center gap-2"
          >
See More of Our Work
<ArrowRight size={18} aria-hidden="true" />
</Link>
        </div>
      </div>
    </section>
  );
}
